import WorkGroupModel from "@/models/lab/WorkGroupModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class WorkGroupCollection extends LabServiceCollection {
  model() {
    return WorkGroupModel;
  }

}
